import { useState, useEffect } from "react";
export function useSessionStorage(key, initialValue = '') {
    // get item from session storage
    function getItemFromStorage(key, initialValue = '') {
        const encodedValue = sessionStorage.getItem(key) ?? '';
        if (encodedValue)
            return JSON.parse(encodedValue);
        // if initial value is a function, call it
        if (typeof (initialValue) === 'function')
            return initialValue();
        return initialValue;
    }
    // set session storage to state
    const [sessionStorageValue, setSessionStorageValue] = useState(() => {
        return getItemFromStorage(key, initialValue);
    });
    useEffect(() => {
        // when session storage state changes, update in session storage
        sessionStorage.setItem(key, JSON.stringify(sessionStorageValue));
    }, [sessionStorageValue]);
    return [sessionStorageValue, setSessionStorageValue];
}
